/* =========================================================================
 * Kkumi · Wishlist Share strip wiring
 * Fills the share URL + social links from the customer's wishlist share URL
 * (via KkwlBus -> grid controller getShareUrl(); falls back to the current
 * page URL). Copy button + generic/instagram icons copy to clipboard + toast;
 * email/sms/facebook/x/pinterest/whatsapp open native share intents.
 * ========================================================================= */
(function () {
  'use strict';

  var strips = document.querySelectorAll('[data-kkwl-share]');
  if (!strips.length) return;

  // Merchant-editable copy (data-* on the section root); literals are the fallback.
  var SHARE_TEXT = strips[0].getAttribute('data-kkwl-share-text') || 'Check out my Kkumi wishlist';
  var COPIED_TOAST = strips[0].getAttribute('data-kkwl-copied-toast') || 'Link copied';
  var COPYFAIL_TOAST = strips[0].getAttribute('data-kkwl-copyfail-toast') || 'Copy failed';

  function currentUrl() {
    var g = window.KkwlBus && window.KkwlBus.grid;
    var u = g && g.getShareUrl && g.getShareUrl();
    return u || window.location.href;
  }

  function fireToast(anchor, msg) {
    var t = document.querySelector('.kk-wish-toast-global');
    if (!t) { t = document.createElement('div'); t.className = 'kk-wish-toast-global'; t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    var rect = anchor.getBoundingClientRect();
    t.textContent = msg;
    t.style.top = (rect.top + window.scrollY - 40) + 'px';
    var raw = rect.left + rect.width / 2;
    var w = t.offsetWidth || 120;
    t.style.left = Math.min(Math.max(raw, w / 2 + 16), window.innerWidth - w / 2 - 16) + 'px';
    t.classList.remove('is-visible'); void t.offsetWidth; t.classList.add('is-visible');
    clearTimeout(t._kkTimer); t._kkTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  function copy(url, anchor) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { fireToast(anchor, COPIED_TOAST); }).catch(function () { fireToast(anchor, COPYFAIL_TOAST); });
    } else { fireToast(anchor, COPIED_TOAST); }
  }

  // Native share intents for platforms that support a web URL; null = copy instead.
  function intentHref(platform, url) {
    var u = encodeURIComponent(url);
    var text = encodeURIComponent(SHARE_TEXT);
    switch (platform) {
      case 'email': return 'mailto:?subject=' + text + '&body=' + u;
      case 'sms': return 'sms:?&body=' + u;
      case 'facebook': return 'https://www.facebook.com/sharer/sharer.php?u=' + u;
      case 'x': return 'https://twitter.com/intent/tweet?url=' + u + '&text=' + text;
      case 'pinterest': return 'https://pinterest.com/pin/create/button/?url=' + u;
      case 'whatsapp': return 'https://wa.me/?text=' + u;
      default: return null; // instagram, generic link -> copy to clipboard
    }
  }

  // In a shared (read-only) view this is someone else's list — sharing your own URL makes no sense.
  if (window.KkwlBus && window.KkwlBus.sharedId) {
    Array.prototype.forEach.call(strips, function (s) { s.style.display = 'none'; });
    return;
  }

  Array.prototype.forEach.call(strips, function (strip) {
    var urlEl = strip.querySelector('[data-kkwl-share-url]');
    var copyBtn = strip.querySelector('[data-action="copy"]');
    var icons = strip.querySelectorAll('[data-kkwl-share-icon]');

    // Bind once; read the URL fresh at click time.
    if (copyBtn) copyBtn.addEventListener('click', function () { copy(currentUrl(), copyBtn); });
    Array.prototype.forEach.call(icons, function (a) {
      var platform = a.getAttribute('data-platform');
      if (!intentHref(platform, 'x')) {
        a.addEventListener('click', function (e) { e.preventDefault(); copy(currentUrl(), a); });
      }
    });

    function refresh() {
      var url = currentUrl();
      if (urlEl) urlEl.textContent = url;
      Array.prototype.forEach.call(icons, function (a) {
        var platform = a.getAttribute('data-platform');
        var href = intentHref(platform, url);
        if (href) {
          a.setAttribute('href', href);
          if (platform !== 'email' && platform !== 'sms') { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener'); }
        } else {
          a.setAttribute('href', '#'); // copy-on-click handler set above
        }
      });
    }

    refresh();
    if (window.KkwlBus) window.KkwlBus.on('ready', refresh); // url firms up once the grid registers
  });
})();
